import { Component, Injectable, OnInit, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';
import { CqScriptService } from '../../../../../common/services/CqScript.service';
import { CqCriteriaService } from '../../../../../common/services/CqCriteria.service';

import * as _ from 'lodash';

declare var $: any;

@Component({
  moduleId: module.id,
  selector: 'cq-script',
  templateUrl: './cq_script.component.html',
  providers: [CqScriptService, BsModalService, CqCriteriaService],
})
@Injectable()
export class CqScriptComponent implements OnInit {
  public dtOptions: any = {};
  public dtTrigger: Subject<any> = new Subject();

  public currentPage = 1;
  public totalRow = 0;
  public page_size = 10;
  public message: { class: string; content: string } = null;
  public list: any = [];
  public listFields: any = [];
  public listFieldsChecked: any = [];
  public model: any = {};
  public valueEditingScore: any = 0;
  public typeModal: string;
  public modalRef: any = {};
  public modalRef2: any = {};
  public types: any = [];
  totalItem: any = 0;
  totalPage: any = 0;
  public modelFilter: any = {};

  public id_delete: number;
  public user: any = {};
  public data_options = [];
  public data_options_copy = [];
  public total = 0;

  constructor(
    private cqService: CqScriptService,
    private criteriaService: CqCriteriaService,
    private modalService: BsModalService,
    private toastr: ToastrService
  ) {
    this.user = JSON.parse(localStorage.getItem('User'));
  }

  ngOnInit() {
    this.types = [
      {
        id: 3,
        text: 'IVR',
      },
      {
        id: 1,
        text: 'ACD',
      },
      {
        id: 0,
        text: 'Outbound',
      },
    ];
    this.loadData();
    this.loadFields();
  }

  loadData(request: any = {}, sort: any = {}) {
    this.list = [];
    request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    if (Object.keys(sort).length == 2) {
      request['sort_by'] = sort.field + ':' + sort.typeSort;
    }

    this.cqService
      .list(request)
      .toPromise()
      .then(
        res => {
          if (res.status == 200 && res.error == false) {
            this.list = res.data.list;
            this.totalItem = res.data.total;
            const pageString = (this.totalItem / this.page_size).toString();
            const pageSplit = pageString.split('.');
            let last: any;
            let totalpage = parseInt(pageSplit[0]);
            if (pageSplit.length > 1) {
              last = pageSplit[1];
              if (parseInt(last) > 0) {
                totalpage++;
              }
            }
            this.totalPage = totalpage;
            if (this.list.criterias) {
              this.listFieldsChecked = this.list.criterias;
            } else {
              this.listFieldsChecked = [];
            }
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: res.status + ' : ' + res.message,
            };
            this.list = [];
            this.listFieldsChecked = [];
            // this.genDataTable();
            this.scrollToTop();
          }
        },
        err => {
          this.message = {
            class: 'alert dark alert-danger',
            content: err.message,
          };
          this.list = [];
          this.listFieldsChecked = [];
          // this.genDataTable();
          this.scrollToTop();
        }
      );
  }
  loadFields() {
    this.criteriaService
      .list({})
      .toPromise()
      .then(res => {
        if (res.status == 200 && res.error == false) {
          this.listFields = res.data.list;
        } else {
          this.listFields = [];
        }
      });
  }

  search() {
    this.currentPage = 1;
    if (this.modelFilter.keyword && this.modelFilter.keyword.trim() != '') {
      this.loadData({ name: this.modelFilter.keyword });
    } else {
      this.loadData();
    }
  }

  sum(data) {
    this.total = 0;
    data.forEach(element => {
      console.log(element);
      if (element.checked) {
        this.total += Number(element.maxscore);
      }
    });
  }

  oncheckboxChanged(data) {
    console.log(data, '---id');
    const check = this.listFieldsChecked.find(value => value == data.id);
    if (check) {
      this.listFieldsChecked = this.listFieldsChecked.filter(value => value !== data.id);
      this.data_options = this.listFields.map(value => {
        const obj = {
          name: value.name,
          id: value._id,
          checked: false,
          isdefault: value.isdefault,
        };
        this.listFieldsChecked.map(item => {
          if (item == value._id) {
            obj.checked = true;
          }
        });
        return obj;
      });
    } else {
      this.listFieldsChecked = [...this.listFieldsChecked, data.id];
      this.data_options = this.listFields.map(value => {
        const obj = {
          name: value.name,
          maxscore: value.maxscore,
          id: value._id,
          checked: false,
          isdefault: value.isdefault,
        };
        this.listFieldsChecked.map(item => {
          if (item == value._id) {
            obj.checked = true;
          }
        });
        return obj;
      });
    }
    this.data_options_copy = Object.assign([], this.data_options);
  }

  scrollToTop() {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  }

  openModal(template: TemplateRef<any>, id?: any) {
    this.message = null;
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-lg',
      keyboard: false,
    };
    this.modalRef = this.modalService.show(template, config);

    this.model = {};
    this.typeModal = id ? 'edit' : 'add';
    this.data_options = this.listFields.map(value => {
      const obj = {
        name: value.name,
        id: value._id,
        checked: false,
        maxscore: value.maxscore,
        isdefault: value.isdefault,
      };
      return obj;
    });
    if (id) {
      this.cqService
        .find(id)
        .toPromise()
        .then(rs => {
          console.log(rs);
          this.listFieldsChecked = rs.data.criterias;
          this.model = {
            form_id: rs.data.id,
            name: rs.data.name,
            good_score: rs.data.good_score,
            normal_score: rs.data.normal_score,
            description: rs.data.description,
          };

          this.renderCriteria(this.data_options, this.listFieldsChecked, null);
          this.sum(this.data_options);
          this.data_options_copy = Object.assign([], this.data_options);
        });
    } else {
      this.listFieldsChecked = [];
      this.total = 0;
    }
  }

  add() {
    if (!this.model.name) {
      return (this.message = {
        class: 'alert dark alert-danger',
        content: 'Tên kịch bản không được bỏ trống !',
      });
    }
    if (!this.model.good_score) {
      return (this.message = {
        class: 'alert dark alert-danger',
        content: 'Mức độ không được bỏ trống !',
      });
    }
    if (!this.model.normal_score) {
      return (this.message = {
        class: 'alert dark alert-danger',
        content: 'Mức độ không được bỏ trống !',
      });
    }
    if (Number(this.model.normal_score) > Number(this.model.good_score)) {
      return (this.message = {
        class: 'alert dark alert-danger',
        content: 'Mức độ không hợp lệ !',
      });
    } else {
      const data = [];
      let check = true;
      if (this.listFieldsChecked.length <= 0) {
        check = false;
        // for (var i = 0; i < this.listFieldsChecked.length; i++) {
        //     $('#opt-info' + i).css('border-color', '');
        //     if (!this.data_options[i].info || (this.data_options[i].info && this.data_options[i].info.trim() == '')) {
        //         $('#opt-info-' + i).css("border-color", 'red');
        //         check = false;
        //     } else {
        //         data.push(this.data_options[i]);
        //     }
        // }
      }
      if (!check) {
        this.message = {
          class: 'alert dark alert-danger',
          content: 'Trường thông tin không được bỏ trống !',
        };
        setTimeout(() => (this.message = null), 3000);
      } else {
        // this.model.data = _.map(data, e => {
        //     if(e.info && e.info.trim() != '') return e;
        // })
        this.model.criterias = this.data_options
          .filter(value => value.checked == true)
          .map(value => ({ id: value.id, maxscore: value.maxscore }));
        this.cqService.create(this.model).subscribe(
          res => {
            if (res) {
              const error = res.error;
              if (error) {
                this.message = {
                  class: 'alert dark alert-danger',
                  content: 'Thêm mới không thành công',
                };
                this.toastr.error('Thêm mới thất bại', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                });
              } else {
                this.message = {
                  class: 'alert dark alert-success',
                  content: 'Thêm mới thành công',
                };
                this.toastr.success('Thêm mới thành công', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                });

                this.loadData();
                this.modalRef.hide();
              }
            }
          },
          error => {
            this.message = {
              class: 'alert dark alert-danger',
              content: error.message,
            };
          }
        );
      }
    }
  }

  edit(data) {
    this.message = null;
    if (!this.model.good_score) {
      return (this.message = {
        class: 'alert dark alert-danger',
        content: 'Mức độ không được bỏ trống !',
      });
    }
    if (!this.model.normal_score) {
      return (this.message = {
        class: 'alert dark alert-danger',
        content: 'Mức độ không được bỏ trống !',
      });
    }
    if (Number(this.model.normal_score) > Number(this.model.good_score)) {
      return (this.message = {
        class: 'alert dark alert-danger',
        content: 'Mức độ không hợp lệ !',
      });
    }
    if (!this.model.name) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Tên kịch bản không được bỏ trống !',
      };
    } else {
      const data = [];
      const check = true;
      if (this.listFieldsChecked.length != 0) {
        // for (var i = 0; i < this.data_options_copy.length; i++) {
        //     $('#opt-info' + i).css('border-color', '');
        //     if (!this.data_options[i].info || (this.data_options[i].info && this.data_options[i].info.trim() == '')) {
        //         $('#opt-info-' + i).css("border-color", 'red');
        //         check = false;
        //     } else {
        //         data.push(this.data_options[i]);
        //     }
        // }
      }
      if (!check) {
        this.message = {
          class: 'alert dark alert-danger',
          content: 'Trường thông tin khóa không được bỏ trống !',
        };
        setTimeout(() => (this.message = null), 3000);
      } else {
        // this.model.data = _.map(data, e => {
        //     if (e.keyword && e.keyword.trim() != '') return e;
        // })
        this.model.data = data;
        const payload = {};
        if (this.model.name) {
          payload['name'] = this.model.name;
        }

        if (this.model.good_score) {
          payload['good_score'] = this.model.good_score;
        }
        if (this.model.normal_score) {
          payload['normal_score'] = this.model.normal_score;
        }

        if (this.model.description) {
          payload['description'] = this.model.description;
        }
        if (this.listFieldsChecked) {
          payload['criterias'] = this.data_options
            .filter(value => value.checked == true)
            .map(value => ({ id: value.id, maxscore: value.maxscore }));
        }
        this.cqService.update(this.model.form_id, payload).subscribe(
          res => {
            if (res) {
              const error = res.error;
              if (error) {
                this.message = {
                  class: 'alert dark alert-danger',
                  content: 'Cập nhật không thành công',
                };
                this.toastr.error('Cập nhật thất bại', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                });
              } else {
                this.message = {
                  class: 'alert dark alert-success',
                  content: 'Cập nhật thành công',
                };
                this.toastr.success('Cập nhật thành công', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                });
                this.loadData();
                this.modalRef.hide();
              }
            }
          },
          error => {
            this.message = {
              class: 'alert dark alert-danger',
              content: error.message,
            };
          }
        );
      }
    }
    this.scrollToTop();
  }

  public changeType(e: any): void {
    this.model.type = e.value;
  }

  openConfirmDelete(template: TemplateRef<any>, id) {
    this.id_delete = id;
    // this.modalRef2 = this.modalService.show(template);
    const y = confirm('Bạn có muốn xóa không?');
    if (y) {
      this.submitDelete();
    }
  }

  submitDelete() {
    this.cqService._delete(this.id_delete).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Xóa không thành công',
            };
            this.toastr.error('Xóa không thành công', error.message, {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.message = {
              class: 'alert dark alert-success',
              content: 'Xóa thành công',
            };
            this.toastr.success('Xóa thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            this.loadData();
            // this.modalRef2.hide();
          }
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
        this.toastr.error('Xóa không thành công', error.message, {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        // this.modalRef2.hide();
      }
    );
  }

  setPage(page: number) {
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadData();
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page <= this.totalPage) {
        // this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage) {
          this.currentPage = page;
          this.loadData();
        }
      }
    }
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  deleteOption(i) {
    this.data_options_copy.splice(i, 1);
    this.data_options.splice(i, 1);
  }
  addOption() {
    this.data_options_copy.push({ info: '', description: '' });
    this.data_options.push({ info: '', description: '' });
  }

  renderCriteria(arrayAll, arraySelected, data) {
    console.log(arrayAll, arraySelected);
    this.data_options = arrayAll.map(value => {
      const obj = {
        name: value.name,
        maxscore: value.maxscore,
        id: value.id,
        checked: false,
        isdefault: value.isdefault,
        updating: false,
      };
      arraySelected.map(item => {
        if (item.id == value.id) {
          obj.checked = true;
          obj.maxscore = item.maxscore ? item.maxscore : value.maxscore;
          console.log(item.maxscore);
        }
      });
      if (data) {
        if (data.updating === value.id) {
          obj.updating = true;
        }
        if (data.saving === value.id && data.score) {
          obj.updating = false;
          obj.maxscore = Number(data.score);
          console.log(obj.maxscore);
        }
      }
      return obj;
    });
  }

  addcriteria(data) {
    this.listFieldsChecked.push({ id: data.id });
    this.renderCriteria(this.data_options, this.listFieldsChecked, null);
    this.sum(this.data_options);
  }
  delecriteria(data) {
    this.listFieldsChecked = this.listFieldsChecked.filter(value => value.id !== data.id);
    this.renderCriteria(this.data_options, this.listFieldsChecked, null);
    this.sum(this.data_options);
  }

  updateScorecriteria(data) {
    this.valueEditingScore = this.data_options.find(value => value.id == data.id).maxscore;
    this.renderCriteria(this.data_options, this.listFieldsChecked, {
      updating: data.id,
    });
  }

  saveScorecriteria(data) {
    this.listFieldsChecked = this.listFieldsChecked.map(value => {
      if (value.id == data.id) {
        value.maxscore = this.valueEditingScore;
      }
      return value;
    });
    this.renderCriteria(this.data_options, this.listFieldsChecked, {
      saving: data.id,
      score: this.valueEditingScore,
    });
    this.sum(this.data_options);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/cq_script/cq_script.component.ts